; var __browserify_shim_require__=require;(function browserifyShim(module, exports, require, define, browserify_shim__define__module__export__) {
/*
NOTE: has custom modifications (to use an external Handlebars instance instead
of ICH's built-in Mustache.js implementation).
*/

/*!
ICanHaz.js version 0.9 -- by @HenrikJoreteg
More info at: http://icanhazjs.com
*/
(function ($) {
/*!
  ICanHaz.js -- by @HenrikJoreteg
*/
/*global jQuery  */
function ICanHaz() {
	var self = this;
	self.VERSION = "0.9";
	self.templates = {};
	self.partials = {};

	// public function for adding templates
	// We're enforcing uniqueness to avoid accidental template overwrites.
	// If you want a different template, it should have a different name.
	self.addTemplate = function (name, templateString) {
		if (self[name]) throw "Invalid name: " + name + ".";
		if (self.templates[name]) throw "Template \" + name + \" exists";

		self.templates[name] = templateString;
		self[name] = function (data, raw) {
			data = data || {};
			var tmp = Handlebars.compile(self.templates[name]);
			var result = tmp(data);
			return raw ? result : $(result);
		};
	};

	// public function for adding partials
	self.addPartial = function (name, templateString) {
		if (self.partials[name]) {
			throw "Partial \" + name + \" exists";
		} else {
			self.partials[name] = templateString;
		}
	};

	// grabs templates from the DOM and caches them.
	// Loop through and add templates.
	// Whitespace at beginning and end of all templates inside <script> tags will
	// be trimmed. If you want whitespace around a partial, add it in the parent,
	// not the partial. Or do it explicitly using <br/> or &nbsp;
	self.grabTemplates = function () {
		$('script[type="text/html"]').each(function (a, b) {
			var script = $((typeof a === 'number') ? b : a), // Zepto doesn't bind this
				text = (''.trim) ? script.html().trim() : $.trim(script.html());

			self[script.hasClass('partial') ? 'addPartial' : 'addTemplate'](script.attr('id'), text);
			script.remove();
		});
	};

	// clears all retrieval functions and empties caches
	self.clearAll = function () {
		for (var key in self.templates) {
			delete self[key];
		}
		self.templates = {};
		self.partials = {};
	};

	self.refresh = function () {
		self.clearAll();
		self.grabTemplates();
	};
}

window.ich = new ICanHaz();

// init itself on document ready
$(function () {
	ich.grabTemplates();
});
})(window.jQuery || window.Zepto);

; browserify_shim__define__module__export__(typeof ich != "undefined" ? ich : window.ich);

}).call(global, undefined, undefined, undefined, undefined, function defineExport(ex) { module.exports = ex; });
